import { useMemo, useState } from "react";
import SectionsAndLayouts from "../../../../Drawers/SectionsAndLayoutsDrawer/SectionsAndLayouts";
import useModule from "../../../../../hooks/useModule";

interface Props {
  form: any;
  setForm: (value: any, key: string) => void;
}

const SectionsAndLayoutsSettings = ({ form, setForm }: Props) => {
  const { module } = useModule(form.ModuleAPIName);
  const [error, setError] = useState();

  const fieldOptions = useMemo(() => {
    return Object.keys(form.Fields).map((key) => {
      return form.Fields[key].Field;
    });
  }, [form]);

  return (
    <>
      <SectionsAndLayouts
        error={error}
        currentModule={module!}
        sections={form?.Layout?.sections ?? []}
        setLayout={(value) => setForm(value, "Layout")}
        publicForm={true}
        fieldOptions={fieldOptions}
      />
    </>
  );
};

export default SectionsAndLayoutsSettings;
